import { BackendForFrontendRepositoryInterface } from "@/services/BFF/interfaces";
import { MailboxInterface } from "@/services/Mailbox/interfaces";
import { AxiosInstance } from "axios";

export class BackendForFrontendRepository implements BackendForFrontendRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance
  ) {

  }

  public async getMailboxForWebsite(websiteId: number): Promise<MailboxInterface> {
    const res = await this.axios.get(`/backend-for-frontend/mailbox?websiteId=${websiteId}`);

    return res.data.mailbox;
  }
}
